import { createSlice } from "@reduxjs/toolkit";
import { fetchOrderFlow } from "./thunk";

interface OrderFlowState {
  data: {
    enquiry: { count: number };
    quotation: { count: number; conversion: number };
    order: { count: number; conversion: number };
    dispatch: { count: number; conversion: number };
  } | null;
  loading: boolean;
  error: string | null;
}

const initialState: OrderFlowState = {
  data: null,
  loading: false,
  error: null,
};

const orderFlowSlice = createSlice({
  name: "orderFlow",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderFlow.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchOrderFlow.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(fetchOrderFlow.rejected, (state, action) => {
        state.loading = false;
        state.error =
          (action.payload as string) ||
          action.error.message ||
          "Failed to fetch order flow data";
        // Set default values on error
        state.data = {
          enquiry: { count: 0 },
          quotation: { count: 0, conversion: 0 },
          order: { count: 0, conversion: 0 },
          dispatch: { count: 0, conversion: 0 },
        };
      });
  },
});

export default orderFlowSlice.reducer;

